export default "__VITE_ASSET__COHxjNob__"